// Third-party libs
require('../../../assets/lib/select2/select2-3.4.5/select2.min.js');
require('../../../assets/lib/fileuploader/fileuploader.js');
require('../../../assets/lib/ngStorage/ngStorage.min.js');

// Stylekit
require('../../../assets/stylekit/js/jv.Tooltip.js');
require('../../../assets/stylekit/js/jv.Breadcrumbs.js');
require('../../../assets/stylekit/js/jv.SortList.js');

// Common
require('../../../assets/scripts/common/jv.i18n.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/jv.EmployeeSelect.js');
require('../../../assets/scripts/common/directives/jv.AjaxSelect.js');
require('../../../assets/scripts/common/polyfills.js');
require('../../../assets/scripts/common/directives/jv.HideOnBlur.js');
require('../../../assets/scripts/common/jv.Jobvite.Urls.js');
require('../../../assets/scripts/common/directives/jv.MessageTemplate.js');
require('../../../assets/scripts/common/jv.TemplateLoader.js');
require('../../../assets/scripts/common/directives/jv.FormTemplate.js');

// Angular modules
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.js');

// Jhire
require('../../../assets/scripts/jhire/jv.directives.webpack.js');
require('../../../assets/scripts/jhire/services/jv.Reqs.js');

// Admin Users
require('../../../assets/scripts/admin/users/jv.Admin.Users.Module.js');
require('../../../assets/scripts/admin/users/accessGroups/jv.Admin.Users.AccessGroups.app.js');
require('../../../assets/scripts/admin/users/accessGroups/jv.Admin.Users.AccessGroups.Ctrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.MainCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.IntroductionCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Ajax.Factory.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.NavigationSVC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.UrlsFAC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.DataSync.Employee.ListCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.DataSync.Employee.SettingsCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Employee.ListCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.EmployeeSVC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.EmployeeSelectFAC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.PostParamFAC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.MessageModalCtrl.js');
require('../../../assets/scripts/admin/users/jv.importEmployee.controller.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.EmployeeCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Employee.FormCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Employee.AddCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Agency.AddCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Agency.DetailsCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Agency.ListCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.AgencySVC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.AddToReqConfigFAC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.SettingsSVC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.SettingsCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Employee.ImportCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.CommonListActionsFAC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.EmployeeAdditionalInfoCtrl.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.app.js');
require('../../../assets/scripts/admin/users/roles/jv.Admin.Users.Roles.app.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.DeleteThreshold.Employee.SettingsCtrl.js');